import qs from 'qs';

export class Pagination {
    pageNumber = 0;
    first = 0;
    pageSize = 10;
    totalRecords;
    filters = {};
    sort = [{ field: 'id', order: 'asc' }];
    multiSort = false;

    getParams() {
        const parameters = {
            page: this.pageNumber.toString(),
            size: this.pageSize.toString(),
            ...this.filters,
        };

        if (this.sort && this.sort.length > 0) {
            const listSort = this.sort
                .map((x) => `${x.field},${x.order}`)
                .reduce((prev, curr) => {
                    prev.push(curr);
                    return prev;
                }, []);

            parameters['sort'] = listSort;
        }

        return {
            params: parameters,
            paramsSerializer: (params) => {
                return qs.stringify(params, { indices: false });
            },
        };
    }

    getPaginateSize() {
        return this.pageNumber + 1;
    }

    toOrder(order) {
        if (order < 0) {
            return 'desc';
        }
        return 'asc';
    }

    paginate($event) {
        this.first = $event.first;
        this.pageNumber = $event.page;
        this.pageSize = $event.rows;
        if ($event.multiSortMeta && $event.multiSortMeta.length > 0) {
            this.sort = $event.multiSortMeta.map((x) => {
                const sort = {
                    field: x.field,
                    order: this.toOrder(x.order),
                };

                return sort;
            });
            this.multiSort = true;
        } else if ($event.sortField !== null) {
            const sort = {
                field: $event.sortField,
                order: this.toOrder($event.sortOrder),
            };
            this.sort = [sort];
            this.multiSort = false;
        }
    }
}
